import { Injectable, OnDestroy, inject } from '@angular/core';
import { MessageBoxComponent } from './message-box.component';
import {DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {take} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class MessageBoxService implements  OnDestroy{
  private dialogService = inject(DialogService);
  private router = inject(Router);
  private translate = inject(TranslateService);


  ref: DynamicDialogRef | undefined;

  public showModal(title: string,
                   message: string,
                   btnOkText: string = 'OK',
                   btnCancelText: string = 'Cancel',
                   redirectURL?: string,
                   messageParams?: object) {
    this.translate.get(title).pipe(take(1)).subscribe({
      next: translatedTitle => {
      this.ref = this.dialogService.open(MessageBoxComponent, {
        width: '50vw',
        contentStyle: { overflow: 'auto' },
        breakpoints: {
          '960px': '75vw',
          '640px': '90vw'
        },
        header: translatedTitle,
        data: {
          message: message,
          btnOkText: btnOkText,
          btnCancelText: btnCancelText,
          messageParams: messageParams
        }
      });

      if (redirectURL) {
        this.ref.onClose.pipe(take(1)).subscribe({
          next: () => {
            this.router.navigate([redirectURL]).then().catch();
          },
          error: err => console.error('[MessageBoxService] Error on dialog close:', err)
        });
      }
    },
      error: err => console.error('[MessageBoxService] Error translating modal title:', err)
    });
  }

  ngOnDestroy(): void {
    if (this.ref) {
      this.ref.close();
    }
  }
}
